import '@angular/compiler';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageManagementComponent } from './page.management/page.management.component';
import { PageTransactionComponent } from './page.transaction/page.transaction.component';
import { PageIpMarketListingsComponent } from './page.ip.market.listings/page.ip.market.listings.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageIpMarketApplicationsComponent } from './page.ip.market.applications/page.ip.market.applications.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageIpMarketStatisticsComponent } from './page.ip.market.statistics/page.ip.market.statistics.component';
import { PageIpManagementOfficesComponent } from './page.ip.management.offices/page.ip.management.offices.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageIpManagementImportComponent } from './page.ip.management.import/page.ip.management.import.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageIpMarketMembersComponent } from './page.ip.market.members/page.ip.market.members.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageIpManagementRenewalsComponent } from './page.ip.management.renewals/page.ip.management.renewals.component';
import { PageIpMarketBuyerInquiriesComponent } from './page.ip.market.buyer.inquiries/page.ip.market.buyer.inquiries.component';
import { PageIpManagementConsultationsComponent } from './page.ip.management.consultations/page.ip.management.consultations.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageIpManagementQnaComponent } from './page.ip.management.qna/page.ip.management.qna.component';
import { PageIpManagementOfficesItemComponent } from './page.ip.management.offices.item/page.ip.management.offices.item.component';
import { PageIpMarketQnaComponent } from './page.ip.market.qna/page.ip.market.qna.component';
import { ComponentIpMarketDocumentsComponent } from './component.ip.market.documents/component.ip.market.documents.component';
import { PageIpManagementSendsComponent } from './page.ip.management.sends/page.ip.management.sends.component';
import { PageIpManagementMember_contentComponent } from './page.ip.management.member_content/page.ip.management.member_content.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';

const INDEX_PAGE = "access";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "management",
                component: PageManagementComponent,
                "app_id": "page.management"
            },
            {
                "path": "transaction",
                component: PageTransactionComponent,
                "app_id": "page.transaction"
            },
            {
                "path": "ip-market/listings",
                component: PageIpMarketListingsComponent,
                "app_id": "page.ip.market.listings"
            },
            {
                "path": "ip-market/applications",
                component: PageIpMarketApplicationsComponent,
                "app_id": "page.ip.market.applications"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "ip-market/statistics",
                component: PageIpMarketStatisticsComponent,
                "app_id": "page.ip.market.statistics"
            },
            {
                "path": "ip-management/offices",
                component: PageIpManagementOfficesComponent,
                "app_id": "page.ip.management.offices"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "ip-management/import",
                component: PageIpManagementImportComponent,
                "app_id": "page.ip.management.import"
            },
            {
                "path": "ip-market/members",
                component: PageIpMarketMembersComponent,
                "app_id": "page.ip.market.members"
            },
            {
                "path": "ip-management/renewals",
                component: PageIpManagementRenewalsComponent,
                "app_id": "page.ip.management.renewals"
            },
            {
                "path": "ip-market/buyer-inquiries",
                component: PageIpMarketBuyerInquiriesComponent,
                "app_id": "page.ip.market.buyer.inquiries"
            },
            {
                "path": "ip-management/consultations",
                component: PageIpManagementConsultationsComponent,
                "app_id": "page.ip.management.consultations"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "ip-management/qna",
                component: PageIpManagementQnaComponent,
                "app_id": "page.ip.management.qna"
            },
            {
                "path": "ip-management/offices/:id",
                component: PageIpManagementOfficesItemComponent,
                "app_id": "page.ip.management.offices.item"
            },
            {
                "path": "ip-market/qna",
                component: PageIpMarketQnaComponent,
                "app_id": "page.ip.market.qna"
            },
            {
                "path": "ip-management/sends",
                component: PageIpManagementSendsComponent,
                "app_id": "page.ip.management.sends"
            },
            {
                "path": "ip-management/member-content",
                component: PageIpManagementMember_contentComponent,
                "app_id": "page.ip.management.member_content"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "signup",
                component: PageSignupComponent,
                "app_id": "page.signup"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
